import { useEffect } from 'react';
import auth from '../../auth/Auth';
import LoadingGlobal from '../../components/LoadingGlobal/LoadingGlobal';
import { limparLastApiCallTime } from '../CaixaMensagem/CaixaMensagemSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';

const LogoutWso2: React.FC<any> = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    auth.logoutGovBr();
    dispatch(limparLastApiCallTime());
  }, []);

  return <LoadingGlobal/>;
}

export default LogoutWso2;
